// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"c0494aa8","320":"119b1786","453":"b9f63659","905":"7cf04309"}[chunkId] + ".chunk.js";
};